import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LdIfDirective } from './services/launchdarkly.directive';

@NgModule({
    declarations: [LdIfDirective],
    exports: [LdIfDirective],
    imports: [CommonModule]
})
export class LaunchDarklyModule { }
